export default "__VITE_ASSET__DtndaYXz__"